/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { GameState } from '../types'
import {
  headerBarStyles,
  // liveBadgeStyles,
  nextBadgeStyles,
  badgeBaseStyles,
  roleLabelStyles,
} from '../styles'
// import LiveBroadcastIcon from '../../../../icons/LiveBroadcastIcon'
import NextBroadcastIcon from '../../../../icons/NextBroadcastIcon'
import colors from '@sportninja/common/constants/appColors'

interface HeaderBarProps {
  gameState: GameState
  userRole: string | null
}

const HeaderBar = ({ gameState, userRole }: HeaderBarProps) => {
  const renderBadge = () => {
    if (gameState.isUpcomingLivestream && !gameState.gameStarted) {
      return (
        <div css={nextBadgeStyles}>
          <NextBroadcastIcon size={24} color={colors.WHITE} />
          <span>Upcoming</span>
        </div>
      )
    }

    // Upcoming/finished without livestream — hidden badge (spacer for role label)
    return (
      <div
        css={css`
          opacity: 0;
          pointer-events: none;
        `}
      >
        <div css={badgeBaseStyles}>
          <span>UPCOMING</span>
        </div>
      </div>
    )
  }

  return (
    <div css={headerBarStyles}>
      {renderBadge()}
      {userRole && <span css={roleLabelStyles}>{userRole}</span>}
    </div>
  )
}

export default HeaderBar
